







import { Component, Vue } from 'vue-property-decorator'
import Sidebar from '@/admin/components/Sidebar.vue'

@Component({
  components: {
    Sidebar
  }
})
export default class AdminMain extends Vue {}
